import UAParser from "ua-parser-js";

export function getDeviceInfo() {
  const parser = new UAParser();
  return parser.getResult().ua;
}
